import React, { useEffect, useState } from 'react'
import { Partner } from '../styles.style'
import { BuyWinService } from '../../../../../services/buy-win.service'
import Regulation from '../components/regulation.component'
import ReactHtmlParser from 'react-html-parser'

const PartnerComponent = ({ props }) => {
	const { partner } = props.match.params
	const [partnerDetail, setPartner] = useState([])
	const [load, setLoad] = useState(false)

	useEffect(() => {
		BuyWinService.getPartnerByInternalUrl(partner).then(res => {
			setPartner(res)
			setLoad(true)
		})
	}, [])

	const {
		summary,
		externalURL,
		name,
		regulation,
		logo,
		point,
		real
	} = partnerDetail

	if (load) {
		return (
			<Partner className="partner">
				<p className="intro">{ReactHtmlParser(summary)}</p>
				<div className="box-partner">
					<figure>
						<a href={externalURL} target="_blank">
							<img
								src={`../../../../../../assets/static/store-partner/${logo}.png`}
								alt={name}
							/>
						</a>
					</figure>
					<div className="partner-list-points">
						{point > 1 ? (
							<p>
								{real.$toReais()} = {point} pontos Muviflex
							</p>
						) : (
							<p>
								{real.$toReais()} = {point} ponto Muviflex
							</p>
						)}
					</div>
					<footer>
						<a
							href={externalURL}
							target="_blank"
							title={`Ir para ${name}`}
							className="go">
							Ir para <span className="name">{name}</span>
						</a>
					</footer>
				</div>

				<Regulation name={name} url={externalURL} regulation={regulation} />
			</Partner>
		)
	} else {
		return null
	}
}

export default PartnerComponent
